"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const getContent_1 = require("../../helpers/getContent");
const getContentType_1 = require("../../helpers/getContentType");
const getCompletionStatusUpdatedEvent_1 = require("../../helpers/getEvent/getCompletionStatusUpdatedEvent");
const getRootContentIdFromState_1 = tslib_1.__importDefault(require("../../helpers/getRootContentIdFromState"));
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
const filter_1 = require("./filter");
function handleForceCompleteAssignment(state) {
    try {
        if (state.contentType === entity_1.ContentType.ASSIGNMENT_CARD) {
            state.actualSubmit = true;
        }
    }
    catch (error) {
        throw new Error('Error in handleForceCompleteAssignment ' + error);
    }
}
function handleForceCompleteScorm(command, state, content, user) {
    const { userId, companyId } = user;
    const stateContent = getContent_1.getContentByContentId(content, state.contentId);
    if (stateContent.content && stateContent.content.subType === 'scorm') {
        const previousComnpletionStatus = state.completionStatus;
        state.scaledProgressMeasure = 1.0;
        state.completionStatus = entity_1.CompletionStatus.COMPLETE;
        const rootContentId = getRootContentIdFromState_1.default(state);
        if (previousComnpletionStatus !== state.completionStatus) {
            const completionStatusUpdatedEvent = getCompletionStatusUpdatedEvent_1.getCompletionStatusUpdatedEvent(command, companyId, userId, stateContent._id, stateContent.contentType, previousComnpletionStatus, state.completionStatus, rootContentId);
            return [completionStatusUpdatedEvent];
        }
    }
    return [];
}
function forceComplete(command, states, user, content) {
    const { timeStamp } = command;
    const events = [];
    const contentType = getContentType_1.getContentType(content);
    const toForceCompleteContentIds = filter_1.filterToForceCompleteContentByContent(command, content);
    const updatedStates = immer_1.default(states, draftStates => {
        const toForceCompleteStates = getState_1.getStatesForUserIdAndContentIds(draftStates, toForceCompleteContentIds, user.userId);
        toForceCompleteStates.forEach(state => {
            if (state.completionStatus === entity_1.CompletionStatus.COMPLETE) {
                return;
            }
            state.forceComplete = true;
            state.updatedAt = timeStamp;
            if (contentType === entity_1.ContentType.COURSE) {
                handleForceCompleteAssignment(state);
                const forceCompleteEvents = handleForceCompleteScorm(command, state, content, user);
                events.push(...forceCompleteEvents);
            }
        });
    });
    return {
        states: updatedStates,
        events
    };
}
exports.forceComplete = forceComplete;
//# sourceMappingURL=forceComplete.js.map